import { render } from "./EstufasDash.vue?vue&type=template&id=79d194d6&scoped=true"
import script from "./EstufasDash.vue?vue&type=script&lang=js"
export * from "./EstufasDash.vue?vue&type=script&lang=js"

import "./EstufasDash.vue?vue&type=style&index=0&id=79d194d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d194d6"]])

export default __exports__